import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { t } from 'i18next';
import accessErrorIcon from '../../assets/icons/error-entry-icon.svg'
import exitErrorIcon from '../../assets/icons/error-exit-icon.svg'
import AccessInput from '../Inputs/AccessInput';
import AccessContext from '../../context/AccessContext/AccessContext';
import ErrorScreen from '../MessagesScreens/ErrorScreen';
import AccessVehiclesContext from '../../context/AccessVehiclesContext/AccessVehiclesContext';
import { getTenantInfoByKey } from '../../helpers/helpers';
import AccessPersonToVisitContext from '../../context/AccessPersonToVisitContext/AccessPersonToVisitContext';
import AccessAreaContext from '../../context/AccessAreaContext/AccessAreaContext';
import AccessEquipmentContext from '../../context/AccessEquipment/AccessEquipmentContext';

const ErrorAccess = () => {

    const { accessState, clean } = useContext(AccessContext);
    const { type, errorType } = accessState

    const { cleanAccessVehiclesState } = useContext(AccessVehiclesContext);
    const { cleanAccessPersonToVisitState } = useContext(AccessPersonToVisitContext);
    const { cleanAccessAreaState } = useContext(AccessAreaContext);
    const { cleanAccessEquipmentState } = useContext(AccessEquipmentContext);

    const navigate = useNavigate();

    const messagesOptions = {
        ACCESS: {
            NO_PARAM: {
                message: t('ERROR_TRY_AGAIN'),
                image: accessErrorIcon
            },
            PARAM_ERROR: {
                message: t('ERROR_DATA_ENTER'),
                image: accessErrorIcon
            },
            NON_ACTIVE_RESOURCE: {
                message: t('ERROR_DATA_ENTER'),
                image: accessErrorIcon
            },
            NONEXISTENCE_ENTITY: {
                message: t('ERROR_DATA_ENTER'),
                image: accessErrorIcon
            },
            CONCURRENCY_ERROR: {
                message: t('CONCURRENCY_ERROR_ACCESS'),
                image: accessErrorIcon
            },
            STATUS_ERROR: {
                message: t('STATUS_ERROR_ACCESS'),
                image: accessErrorIcon
            },
            AUTH_ERROR: {
                message: t('TOKEN_ERROR'),
                image: accessErrorIcon
            },
            INTERNAL_SERVER_ERROR: {
                message: t('SERVER_ERROR'),
                image: accessErrorIcon
            },
            PROFILE_ACCESS_ERROR: {
                message: t('PERMISSIONS_ERROR'),
                image: accessErrorIcon
            },
            MANDATORY_PEOPLE_TO_VISIT: {
                message: t('MANDATORY_PEOPLE_TO_VISIT_ERROR'),
                image: accessErrorIcon
            },
            MAXIMUM_PEOPLE_TO_VISIT: {
                message: t('MAXIMUM_PEOPLE_TO_VISIT_ERROR'),
                image: accessErrorIcon
            },
            NOT_ACCESS_OPENING: {
                message: `${t('NOT_ACCESS_OPENING_START')} ${getTenantInfoByKey('opening_name')} ${t('NOT_ACCESS_OPENING_START_MID')} ${getTenantInfoByKey('opening_name')} ${t('NOT_ACCESS_OPENING_MID')} ${getTenantInfoByKey('opening_name')} ${t('NOT_ACCESS_OPENING_END')}`,
                image: accessErrorIcon
            },
            BUILDINGS_WITHOUT_OPENING: {
                message: `${t('BUILDINGS_WITHOUT_OPENING_START')} ${getTenantInfoByKey('building_name')} ${t('BUILDINGS_WITHOUT_OPENING_START_MID')} ${getTenantInfoByKey('building_name')} ${t('BUILDINGS_WITHOUT_OPENING_MID')} ${getTenantInfoByKey('building_name')} ${t('BUILDINGS_WITHOUT_OPENING_END')}`,
                image: accessErrorIcon
            },
            EQUIPMENT_NOT_EXIST_OR_DISABLED: {
                message: t('EQUIPMENT_NOT_EXIST_OR_DISABLED_ERROR'),
                image: accessErrorIcon
            },
        },
        EXIT: {
            NO_PARAM: {
                message: t('ERROR_TRY_AGAIN'),
                image: exitErrorIcon
            },
            PARAM_ERROR: {
                message: t('ERROR_DATA_ENTER'),
                image: exitErrorIcon
            },
            NONEXISTENCE_ENTITY: {
                message: t('ERROR_DATA_ENTER'),
                image: exitErrorIcon
            },
            CONCURRENCY_ERROR: {
                message: t('CONCURRENCY_ERROR_EXIT'),
                image: exitErrorIcon
            },
            AUTH_ERROR: {
                message: t('TOKEN_ERROR'),
                image: exitErrorIcon
            },
            INTERNAL_SERVER_ERROR: {
                message: t('SERVER_ERROR'),
                image: exitErrorIcon
            },
            PROFILE_ACCESS_ERROR: {
                message: t('PERMISSIONS_ERROR'),
                image: exitErrorIcon
            },
        },
        ACCESS_VISIT: {
            NO_PARAM: {
                message: t('ERROR_TRY_AGAIN'),
                image: accessErrorIcon
            },
            PARAM_ERROR: {
                message: t('ERROR_DATA_ENTER'),
                image: accessErrorIcon
            },
            NONEXISTENCE_ENTITY: {
                message: t('ERROR_DATA_ENTER'),
                image: accessErrorIcon
            },
            CONCURRENCY_ERROR: {
                message: t('CONCURRENCY_ERROR_ACCESS_VISIT'),
                image: accessErrorIcon
            },
            STATUS_ERROR: {
                message: t('STATUS_ERROR_ACCESS_VISIT'),
                image: accessErrorIcon
            },
            AUTH_ERROR: {
                message: t('TOKEN_ERROR'),
                image: accessErrorIcon
            },
            PARAM_MISSMATCH: {
                message: t('PARAM_MISSMATCH'),
                image: accessErrorIcon
            },
            INTERNAL_SERVER_ERROR: {
                message: t('SERVER_ERROR'),
                image: accessErrorIcon
            },
            PROFILE_ACCESS_ERROR: {
                message: t('PERMISSIONS_ERROR'),
                image: accessErrorIcon
            },
            MANDATORY_PEOPLE_TO_VISIT: {
                message: t('MANDATORY_PEOPLE_TO_VISIT_ERROR'),
                image: accessErrorIcon
            },
            NOT_ACCESS_OPENING: {
                message: `${t('NOT_ACCESS_OPENING_START')} ${getTenantInfoByKey('opening_name')} ${t('NOT_ACCESS_OPENING_START_MID')} ${getTenantInfoByKey('opening_name')} ${t('NOT_ACCESS_OPENING_MID')} ${getTenantInfoByKey('opening_name')} ${t('NOT_ACCESS_OPENING_END')}`,
                image: accessErrorIcon
            },
            BUILDINGS_WITHOUT_OPENING: {
                message: `${t('BUILDINGS_WITHOUT_OPENING_START')} ${getTenantInfoByKey('building_name')} ${t('BUILDINGS_WITHOUT_OPENING_START_MID')} ${getTenantInfoByKey('building_name')} ${t('BUILDINGS_WITHOUT_OPENING_MID')} ${getTenantInfoByKey('building_name')} ${t('BUILDINGS_WITHOUT_OPENING_END')}`,
                image: accessErrorIcon
            },
            MAXIMUM_PEOPLE_TO_VISIT: {
                message: t('MAXIMUM_PEOPLE_TO_VISIT'),
                image: accessErrorIcon
            },
            EQUIPMENT_NOT_EXIST_OR_DISABLED: {
                message: t('EQUIPMENT_NOT_EXIST_OR_DISABLED_ERROR'),
                image: accessErrorIcon
            },
        },
        EXIT_VISIT: {
            NO_PARAM: {
                message: t('ERROR_TRY_AGAIN'),
                image: exitErrorIcon
            },
            PARAM_ERROR: {
                message: t('ERROR_DATA_ENTER'),
                image: exitErrorIcon
            },
            NONEXISTENCE_ENTITY: {
                message: t('ERROR_DATA_ENTER'),
                image: exitErrorIcon
            },
            CONCURRENCY_ERROR: {
                message: t('CONCURRENCY_ERROR_EXIT_VISIT'),
                image: exitErrorIcon
            },
            AUTH_ERROR: {
                message: t('TOKEN_ERROR'),
                image: exitErrorIcon
            },
            INTERNAL_SERVER_ERROR: {
                message: t('SERVER_ERROR'),
                image: exitErrorIcon
            },
            PROFILE_ACCESS_ERROR: {
                message: t('PERMISSIONS_ERROR'),
                image: exitErrorIcon
            },
        }
    }

    const message = messagesOptions[type][errorType];

    const getBack = () => {
        navigate('/dashboard');
        clean();
        cleanAccessVehiclesState();
        cleanAccessPersonToVisitState();
        cleanAccessAreaState();
        cleanAccessEquipmentState();
    }

    return (
        <div>
            <AccessInput />
            <ErrorScreen
                title={'Error'}
                description={message.message}
                image={message.image}
                withButton
                buttonTitle={t('GET_BACK')}
                onClickButton={getBack}
            />
        </div>
    );
}

export default ErrorAccess